import { Box, HStack, Text } from "@chakra-ui/react";
import { Icon } from "../../Icon";

/**
 * @param {number} number
 * @returns {string}
 */
function getNumberExtension(number) {
  if (number >= 1000000) {
    let millions = number / 1000000;
    return `${millions.toFixed(2).replace(/\.00$/, "")}M`;
  } else if (number >= 1000) {
    let thousands = number / 1000;
    return `${thousands.toFixed(2).replace(/\.00$/, "")}k`;
  }
  return number.toString();
}

/**
 * @typedef {Object} Props
 * @property {number} number
 * @property {string} icon
 */
/**
 * @param {Props} props
 */
export function SocialsCardTags(props) {
  const { number, icon } = props;

  return (
    <HStack
      py=".2rem"
      px=".5rem"
      borderRadius="full"
      _hover={{ bg: "gray.200" }}>
      <Box mb="2px">
        <Icon icon={icon} color="gray.600" size=".875rem" />
      </Box>

      <Text color="gray.600" fontSize=".875rem">
        {getNumberExtension(number)}
      </Text>
    </HStack>
  );
}
